import { useState } from "react";
import { Text, View, StyleSheet, TextInput, Button, Platform } from "react-native";
import * as SecureStore from "expo-secure-store";
import * as AsyncStorage from "@react-native-async-storage/async-storage";
import { CustomAlert } from "@/components/ThemedAlert";

// See: https://docs.expo.dev/versions/latest/sdk/securestore/#example-appjson-with-config-plugin

// Web uses AsyncStorage while Android uses SecureStore!
async function save(key: string, value: string) {
  try {
    if (Platform.OS === "web") {
      await AsyncStorage.default.setItem(key, value);
    } else {
      // mobile
      await SecureStore.setItemAsync(key, value);
    }
  } catch (error) {
    console.error("Error saving data:", error);
  }
}

async function getValueFor(key: string) {
  try {
    if (Platform.OS === "web") {
      const result = await AsyncStorage.default.getItem(key);
      if (result) {
        CustomAlert.alert("Secure Value", "🔐 Here's your value 🔐 \n" + result);
      } else {
        CustomAlert.alert("Secure Value", "No values stored under that key.");
      }
    } else {
      const result = await SecureStore.getItemAsync(key);
      if (result) {
        CustomAlert.alert("Secure Value", "🔐 Here's your value 🔐 \n" + result);
      } else {
        CustomAlert.alert("Secure Value", "No values stored under that key.");
      }
    }
  } catch (error) {
    console.error("Error retrieving data:", error);
  }
}

export default function TestSecureStoreScreen() {
  const [key, onChangeKey] = useState("Your key here");
  const [value, onChangeValue] = useState("Your value here");

  return (
    <View style={styles.container}>
      <Text style={styles.paragraph}>Save an item, and grab it later!</Text>

      <TextInput style={styles.textInput} clearTextOnFocus onChangeText={(text) => onChangeKey(text)} value={key} />
      <TextInput style={styles.textInput} clearTextOnFocus onChangeText={(text) => onChangeValue(text)} value={value} />

      <Button
        title="Save this key/value pair"
        onPress={() => {
          save(key, value);
          onChangeKey("Your key here");
          onChangeValue("Your value here");
        }}
      />
      <Text style={styles.paragraph}>🔐 Enter your key 🔐</Text>
      <TextInput
        style={styles.textInput}
        onSubmitEditing={(event) => {
          getValueFor(event.nativeEvent.text);
        }}
        placeholder="Enter the key for the value you want to get"
      />
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    justifyContent: "center",
    paddingTop: 10,
    backgroundColor: "#ecf0f1",
    padding: 8,
  },
  paragraph: {
    marginTop: 34,
    margin: 24,
    fontSize: 18,
    fontWeight: "bold",
    textAlign: "center",
  },
  textInput: {
    height: 35,
    borderColor: "gray",
    borderWidth: 0.5,
    padding: 4,
  },
});
